<template>
  <ul class="flex w-full mb-4 shadow" style="border-bottom: 1px solid #B7BDCD">
    <li
      :class="[
        'flex',
        'items-center',
        'justify-center',
        'custom-tab',
        tab.id === currentTab ? 'custom-tab__active' : 'custom-tab__inactive',
      ]"
      style=""
      v-for="tab in tabs"
      :key="tab.id"
      @click="$emit('current-tab', tab.id)"
      class="text-xs lg:text-base"
    >
      {{ tab.value }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "MuleexTab",
  props: ["tabs", "currentTab"],
};
</script>

<style lang="scss" scoped>
.custom-tab {
  width:187.74px;
  height: 32px;
  cursor: pointer;

  &__active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    color: #fcc210;
  }

  &__inactive {
    background: #e6ecf1;
    color: #5e646d;
  }
}

@media (max-width: 999px){
  .custom-tab{
    font-size: 12px;
  }
}
</style>
